import { FormItem, SelectInput, useField } from '@framework/form';
import { Collapse } from 'antd';
import { useWatch } from 'react-hook-form';
import { useTreeReferencesContext } from '../../../../../tree/references';
import { StyledDrawerCollapse } from '../../../../../ui/drawer';
import { useAsyncServiceEngineContext } from '../../../../expressions/repository/async/context/AsyncServicesEngineContext';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { CommonConfigComponent } from '../common/CommonInputConfigComponent';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';
import { ServiceSelectorInput } from './components/ServiceSelectorInput';
import { AsyncSelectServiceConfigForm } from './components/service-config/AsyncSelectServiceConfigForm';
import { AsynceSelectServiceTableConfigForm } from './components/service-config/AsynceSelectServiceTableConfigForm';
import { useLabelFieldFixer } from './hooks/useLabelFieldFixer';
const { Panel } = Collapse;

export interface IAsyncSelectConfigComponentProps
  extends IWidgetComponentProps<IAsyncSelectWidget> {}

export function AsyncSelectConfigComponent(
  props: IAsyncSelectConfigComponentProps,
) {
  const { references } = useTreeReferencesContext();
  const { services } = useAsyncServiceEngineContext();

  const selectedId = useWatch({ name: `serviceId` });
  const selected = services.find(s => s.id === selectedId);

  const { setValue: setLabelFields } = useField('labelFields');
  const { setValue: setValueField } = useField('valueField');
  const { setValue: setSearchField } = useField('searchField');
  const { setValue: setInputsField } = useField('inputs');
  const { setValue: setOutputsField } = useField('outputs');

  const searchField = useWatch({ name: `searchField` });

  const hasInputs = selected?.inputs && selected?.inputs.length > 0;

  // Hook con useEffect()
  // Necessario per la retrocompatibilità.
  useLabelFieldFixer();

  const renderType = useWatch({ name: 'renderType' });

  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'service']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <FormItem name="renderType" label="Tipo di visualizzazione">
          <SelectInput
            name="renderType"
            options={[
              { label: 'Menù a tendina', value: 'select' },
              { label: 'Tabella', value: 'table' },
            ]}
          />
        </FormItem>

        <CommonConfigComponent {...props} hideConfigDefaultValue />
      </Panel>
      <Panel header="Impostazioni Servizio" key="service">
        <div>
          <ServiceSelectorInput
            onChange={(value, option, onChange) => {
              onChange(value);
              setLabelFields([]);
              setValueField(null);
              setSearchField(null);
              setInputsField({});
              setOutputsField((option as any).service.outputs);
            }}
            name="serviceId"
          />

          {/* Configurazione I/O servizio (modalità select) */}
          <AsyncSelectServiceConfigForm
            selected={selected}
            hasInputs={hasInputs}
            searchField={searchField}
            references={references}
          />
          {/* Configurazione I/O servizio (modalità tabella) */}
          {renderType !== 'table' && (
            <AsynceSelectServiceTableConfigForm
              selected={selected}
              hasInputs={hasInputs}
              references={references}
              hasValue={true}
            />
          )}
        </div>
      </Panel>
    </StyledDrawerCollapse>
  );
}
